import {
  CheckIcon,
  ChevronRightIcon,
  ChevronUpIcon,
  FilterIcon,
  PlusIcon,
  TrashIcon,
  XCircleFillIcon,
  XIcon,
} from "@primer/octicons-react";
import { Box, Checkbox, IconButton } from "@primer/react";
import NumberBox from "devextreme-react/number-box";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useSelector } from "react-redux";
import { AddKhoanNopModalRespone } from "..";
import { saleSetApi } from "../../../api/saleSetApi";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import TextInput from "../../../components/ui/text-input";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { SalesetKhoanNopGroupTypeModal } from "../../../pages/sf-saleset-khoannopgroup-type/SalesetKhoanNopGroupTypeModal";
import { RootState } from "../../../state/reducers";
import { DefaultPopup } from "../../modal";
import { ALL_HTNBS, GroupHtnbFilter, LocHinhThucNopModal } from "./LocHinhThucNopModal";
import { ThemKhoanNopModal } from "./ThemKhoanNopModal";
import { ThemHeClbKhacModal } from "./ThemHeClbKhacModal";
type AddKhoanNopFromSalesetProps = {
  onSelected: (data: AddKhoanNopModalRespone) => void;
  onCancel: () => void;
  isSaving: boolean;
  nam_hoc: string;
  ts_hocsinh_id: number;
  sf_hinhthucnopbom_ids?: string;
  ngay_nhap_hoc_lai?: string;
};

export const AddKhoanNopFromSaleset = (
  props: AddKhoanNopFromSalesetProps
) => {
  const { dm_coso_id } = useSelector((state: RootState) => state.common);
  const [sf_mucthuphi_selected_ids, set_sf_mucthuphi_selected_ids] = useState<
    number[]
  >([]);
  const [is_tinh_mien_giam] = useState<boolean>(true);
  const [sf_mucthuphi_datasource, set_sf_mucthuphi_datasource] = useState<
    any[]
  >([]);
  const [groupHtnbFilter, setGroupHtnbFilter] = useState<GroupHtnbFilter>(
    new Map()
  );
  const [summary, setSummary] = useState<number>();
  const [expandedGroups, setExpandedGroups] = useState<Map<string, string>>(
    new Map()
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowHinhThucModal, setIsShowHinhThucModal] = useState(false);
  const [isShowLocModal, setIsShowLocModal] = useState(false);
  const [isShowThemKhoanNopModal, setIsShowThemKhoanNopModal] = useState(false);
  const [isShowThemHeClbKhacModal, setIsShowThemHeClbKhacModal] = useState(false);
  const [hidingId, setHidingId] = useState<number | null>(null);

  const handleHideItem = useCallback(async (sf_khoannop_id: number) => {
    setHidingId(sf_khoannop_id);
    try {
      const res = await saleSetApi.hideItems({
        nam_hoc: props.nam_hoc,
        ts_hocsinh_id: props.ts_hocsinh_id,
        sf_khoannop_ids: [sf_khoannop_id],
      });
      if (res.is_success) {
        set_sf_mucthuphi_datasource((prev) => prev.filter((x) => x.sf_khoannop_id !== sf_khoannop_id));
      }
    } finally {
      setHidingId(null);
    }
  }, [props.nam_hoc, props.ts_hocsinh_id]);

  const handleReloadSaleset = useCallback(async () => {
    if (!props.nam_hoc || !props.ts_hocsinh_id) return;

    setIsLoading(true);

    try {
      const request = {
        nam_hoc: props.nam_hoc,
        ts_hocsinh_id: props.ts_hocsinh_id,
      };
      const res = await saleSetApi.selectByStudent(request);

      if (res.is_success && Array.isArray(res.data)) {
        const sf_mucthuphi_datasource = res.data
          .filter((x: any) => {
            const hasNgayNhapHocLai = Boolean(x.ngay_nhap_hoc_lai || props.ngay_nhap_hoc_lai);
            const isNhapHocLaiFee = Boolean(x.is_hien_thi_nhap_hoc_lai && hasNgayNhapHocLai);
            if (isNhapHocLaiFee) return true;

            return !(x.sf_loaikhoannop_id === 1 && (x.so_tien_da_nop || 0) > 0 && (x.so_tien_thua_thieu || 0) >= 0) &&
              x.sf_loaikhoannop_id !== 2;
          })
          .map((x: any) => {
            const sf_khoannop_id = x.sf_khoannop_id || 0;
            const hasNgayNhapHocLai = Boolean(x.ngay_nhap_hoc_lai || props.ngay_nhap_hoc_lai);
            const isNhapHocLaiFee = Boolean(x.is_hien_thi_nhap_hoc_lai && hasNgayNhapHocLai);
            return {
              id: sf_khoannop_id,
              sf_khoannop_id: sf_khoannop_id,
              sf_mucthuphi_id: sf_khoannop_id,
              sf_khoannop_group_id: x.sf_khoannop_group_id,
              ma_khoan_nop: x.ma_khoan_nop || x.ma_khoannop,
              ten_khoan_nop: x.ten_khoan_nop || x.ten_khoannop,
              nhom_khoan_nop: x.nhom_khoan_nop || x.nhom_khoannop || "Khác",
              // phục vụ sắp xếp
              thutu_sapxep_nhomkhoannop: x.thutu_sapxep_nhomkhoannop ?? x.thu_tu_nhom ?? 0,
              thutu_sapxep: x.thutu_sapxep ?? x.thu_tu ?? 0,
              // Loại 1 (1 lần/năm): tính phần còn thiếu theo công thức quy đổi ngược
              //   dinh_muc_can_gui = con_thieu_thuc × dinh_muc / phai_nop
              // Loại khác (nhiều lần): luôn trả về định mức gốc
              so_tien: (() => {
                const dinh_muc = x.so_tien_dinh_muc || 0;
                if (isNhapHocLaiFee && (x.so_tien_da_nop || 0) > 0) {
                  return x.so_tien_dinh_muc_goc ?? dinh_muc;
                }
                if (x.sf_loaikhoannop_id !== 1 && x.sf_loaikhoannop_id !== 3) return dinh_muc;
                const mien_giam = x.so_tien_mien_giam || 0;
                const da_nop = x.so_tien_da_nop || 0;
                const hoan_phi = x.so_tien_hoan_phi || 0;
                const phai_nop = dinh_muc - mien_giam;
                if (phai_nop <= 0) return 0;
                const con_thieu = phai_nop - da_nop + hoan_phi;
                if (con_thieu <= 0) return x.sf_loaikhoannop_id === 3 ? (x.so_tien_dinh_muc_goc ?? dinh_muc) : dinh_muc;
                return Math.round(con_thieu * dinh_muc / phai_nop);
              })(),
              so_tien_phai_nop: (() => {
                const dinh_muc = x.so_tien_dinh_muc || 0;
                if (isNhapHocLaiFee && (x.so_tien_da_nop || 0) > 0) {
                  return x.so_tien_dinh_muc_goc ?? dinh_muc;
                }
                if (x.sf_loaikhoannop_id !== 1 && x.sf_loaikhoannop_id !== 3) return dinh_muc;
                const mien_giam = x.so_tien_mien_giam || 0;
                const da_nop = x.so_tien_da_nop || 0;
                const hoan_phi = x.so_tien_hoan_phi || 0;
                const phai_nop = dinh_muc - mien_giam;
                if (phai_nop <= 0) return 0;
                const con_thieu = phai_nop - da_nop + hoan_phi;
                if (con_thieu <= 0) return x.sf_loaikhoannop_id === 3 ? (x.so_tien_dinh_muc_goc ?? dinh_muc) : dinh_muc;
                return Math.round(con_thieu * dinh_muc / phai_nop);
              })(),
              so_tien_mien_giam: x.so_tien_mien_giam || 0,
              so_tien_hoan_phi: x.so_tien_hoan_phi || 0,
              so_tien_da_nop: x.so_tien_da_nop || 0,
              ghi_chu: x.ghi_chu || "",
              sf_hinhthucnopbom_ids: x.sf_hinhthucnopbom_ids,
              thang: x.thang ?? 0,
              is_dichvu: x.is_dichvu ?? false,
              is_dichvu_fixed: x.is_dichvu_fixed ?? false,
              is_tinhcongno: x.is_tinhcongno ?? false,
              is_khoannop_undefined: x.is_khoannop_undefined ?? false,
              is_hien_thi_nhap_hoc_lai: x.is_hien_thi_nhap_hoc_lai ?? false,
              ngay_nhap_hoc_lai: x.ngay_nhap_hoc_lai || props.ngay_nhap_hoc_lai,
              isShowPayment: x.isShowPayment ?? false,
              sf_hachtoan_congno_id: 0,
              sf_loaikhoannop_id: x.sf_loaikhoannop_id,
            };
          }).filter((x: any) => {
            const hasNgayNhapHocLai = Boolean(x.ngay_nhap_hoc_lai || props.ngay_nhap_hoc_lai);
            const isNhapHocLaiFee = Boolean(x.is_hien_thi_nhap_hoc_lai && hasNgayNhapHocLai);
            if (isNhapHocLaiFee) return true;

            return x.sf_loaikhoannop_id === 1 || x.sf_loaikhoannop_id === 3;
          });

        set_sf_mucthuphi_datasource(sf_mucthuphi_datasource);
      } else {
        set_sf_mucthuphi_datasource([]);
      }
    } catch (error) {
      set_sf_mucthuphi_datasource([]);
    } finally {
      setIsLoading(false);
    }
  }, [props.nam_hoc, props.ts_hocsinh_id, props.ngay_nhap_hoc_lai]);

  useEffect(() => {
    handleReloadSaleset();
  }, [handleReloadSaleset]);

  const raw_data_source = useMemo(() => {
    return sf_mucthuphi_datasource.map((item) => ({
      ...item,
      so_tien_phai_nop: item.so_tien_phai_nop || item.so_tien || 0,
    }));
  }, [sf_mucthuphi_datasource]);

  const filtered_raw_data_source = useMemo(() => {
    if (!raw_data_source || raw_data_source.length === 0) return [];
    if (groupHtnbFilter.size === 0) return raw_data_source;

    return raw_data_source.filter((item: any) => {
      const hasNgayNhapHocLai = Boolean(item.ngay_nhap_hoc_lai || props.ngay_nhap_hoc_lai);
      if (item.is_hien_thi_nhap_hoc_lai && hasNgayNhapHocLai) return true;

      // Chỉ lọc khoản nộp là dịch vụ
      // if (!item.is_dichvu && !item.is_dichvu_fixed) return true;
      if (item.is_tinhcongno) return true;

      const groupKey = String(item.sf_khoannop_group_id || "");
      const selectedIds = groupHtnbFilter.get(groupKey);
      if (!selectedIds || selectedIds.length === 0) return true; // nhóm chưa lọc → hiển thị hết

      // Gộp tất cả thangs từ các htnb được chọn
      const allowedThangs = new Set<number>();
      selectedIds.forEach((id) => {
        const htnb = ALL_HTNBS.find((h) => h.id === id);
        if (htnb?.thangs) {
          htnb.thangs.split(",")
            .map((t) => parseInt(t.trim(), 10))
            .filter((t) => !isNaN(t))
            .forEach((t) => allowedThangs.add(t));
        }
      });

      if (allowedThangs.size === 0) return true;
      return allowedThangs.has(item.thang ?? 0);
    });
  }, [raw_data_source, groupHtnbFilter]);

  const data_source = useMemo(() => {
    const getOrder = (item: any): { thuTuNhom: number; thuTu: number } => {
      return {
        thuTuNhom: Number(item.thutu_sapxep_nhomkhoannop) || 0,
        thuTu: Number(item.thutu_sapxep) || 0,
      };
    };

    const groupedData: Record<string, any[]> = {};
    filtered_raw_data_source.forEach((item: any) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }
      groupedData[groupKey].push(item);
    });

    const result: any[] = [];
    const sortedGroupKeys = Object.keys(groupedData).sort((a, b) => {
      const ordersA = groupedData[a].map(getOrder);
      const ordersB = groupedData[b].map(getOrder);

      const minNhomA = Math.min(...ordersA.map((o) => o.thuTuNhom));
      const minNhomB = Math.min(...ordersB.map((o) => o.thuTuNhom));
      if (minNhomA !== minNhomB) return minNhomA - minNhomB;

      const minThuTuA = Math.min(...ordersA.map((o) => o.thuTu));
      const minThuTuB = Math.min(...ordersB.map((o) => o.thuTu));
      if (minThuTuA !== minThuTuB) return minThuTuA - minThuTuB;

      return String(a).localeCompare(String(b), "vi");
    });

    sortedGroupKeys.forEach((groupKey) => {
      result.push({
        id: `group_${groupKey}`,
        isGroupHeader: true,
        nhom_khoan_nop: groupKey,
        ma_khoan_nop: "",
        ten_khoan_nop: `Nhóm: ${groupKey}`,
        groupItems: groupedData[groupKey],
        isExpanded: expandedGroups.has(groupKey),
      });

      if (expandedGroups.has(groupKey)) {
        const sortedItems = [...groupedData[groupKey]].sort((x: any, y: any) => {
          const a = getOrder(x);
          const b = getOrder(y);
          if (a.thuTu !== b.thuTu) return a.thuTu - b.thuTu;
          return String(x.ma_khoan_nop || "").localeCompare(
            String(y.ma_khoan_nop || ""),
            "vi"
          );
        });

        sortedItems.forEach((item) => {
          result.push({
            ...item,
            isGroupHeader: false,
            parentGroup: groupKey,
          });
        });
      }
    });

    return result;
  }, [filtered_raw_data_source, expandedGroups]);

  const uniqueGroupsStr = useMemo(() => {
    if (filtered_raw_data_source.length === 0) return "";
    const uniqueGroups = new Set<string>();
    filtered_raw_data_source.forEach((item) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      uniqueGroups.add(groupKey);
    });
    return Array.from(uniqueGroups).sort().join(",");
  }, [filtered_raw_data_source]);

  useEffect(() => {
    if (!uniqueGroupsStr) return;

    setExpandedGroups((prev) => {
      const currentGroups = Array.from(prev.keys()).sort().join(",");
      if (currentGroups !== uniqueGroupsStr) {
        const newExpandedGroups = new Map<string, string>();
        uniqueGroupsStr.split(",").forEach((groupKey) => {
          newExpandedGroups.set(groupKey, groupKey);
        });
        return newExpandedGroups;
      }
      return prev;
    });
  }, [uniqueGroupsStr]);

  useEffect(() => {
    const totalAmount = raw_data_source
      .filter((x) => sf_mucthuphi_selected_ids.includes(x.id))
      .reduce((count, item) => {
        return (
          count +
          (item.so_tien_phai_nop === undefined || item.so_tien_phai_nop === 0
            ? item.so_tien
            : item.so_tien_phai_nop)
        );
      }, 0);
    setSummary(totalAmount);
  }, [sf_mucthuphi_selected_ids, raw_data_source]);

  const toggleGroup = useCallback((groupKey: string) => {
    setExpandedGroups((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(groupKey)) {
        newMap.delete(groupKey);
      } else {
        newMap.set(groupKey, groupKey);
      }
      return newMap;
    });
  }, []);

  const handleGroupSelection = useCallback(
    (groupKey: string, isSelected: boolean) => {
      const groupItems = filtered_raw_data_source.filter(
        (item) => (item.nhom_khoan_nop || "Khác") === groupKey
      );
      const groupItemIds = groupItems.map((item) => item.id);

      if (isSelected) {
        const newSelection = [...sf_mucthuphi_selected_ids];
        groupItemIds.forEach((id) => {
          if (!newSelection.includes(id)) {
            newSelection.push(id);
          }
        });
        set_sf_mucthuphi_selected_ids(newSelection);
      } else {
        const newSelection = sf_mucthuphi_selected_ids.filter(
          (id) => !groupItemIds.includes(id)
        );
        set_sf_mucthuphi_selected_ids(newSelection);
      }
    },
    [filtered_raw_data_source, sf_mucthuphi_selected_ids]
  );

  const handleItemSelection = useCallback(
    (itemId: number, isSelected: boolean) => {
      if (isSelected) {
        if (!sf_mucthuphi_selected_ids.includes(itemId)) {
          set_sf_mucthuphi_selected_ids([...sf_mucthuphi_selected_ids, itemId]);
        }
      } else {
        set_sf_mucthuphi_selected_ids(
          sf_mucthuphi_selected_ids.filter((id) => id !== itemId)
        );
      }
    },
    [sf_mucthuphi_selected_ids]
  );

  const handleSoTienChange = useCallback((rowId: number, value: number) => {
    set_sf_mucthuphi_datasource((prev) => {
      const found = prev.find((x) => x.id === rowId);
      if (found && found.so_tien_phai_nop === value) {
        return prev;
      }
      return prev.map((x) => {
        if (x.id === rowId) {
          return { ...x, so_tien_phai_nop: value };
        }
        return x;
      });
    });
  }, []);

  const handleGhiChuChange = useCallback((rowId: number, value: string) => {
    set_sf_mucthuphi_datasource((prev) => {
      const found = prev.find((x) => x.id === rowId);
      if (found && found.ghi_chu === value) {
        return prev;
      }
      return prev.map((x) => {
        if (x.id === rowId) {
          return { ...x, ghi_chu: value };
        }
        return x;
      });
    });
  }, []);

  const handelSubmit = () => {
    const data = {
      sf_bom_id: 0,
      is_calculate_miengiam: is_tinh_mien_giam,
      sf_bom_chitiets: sf_mucthuphi_datasource.filter((x) =>
        sf_mucthuphi_selected_ids.includes(x.id)
      ),
      sf_mucthuphis: sf_mucthuphi_datasource.filter((x) =>
        sf_mucthuphi_selected_ids.includes(x.id)
      ),
      sf_hinhthucnopbom_id: 0,
    };
    props.onSelected(data);
  };

  const isAllSelected = useMemo(() => {
    return filtered_raw_data_source.length > 0 && filtered_raw_data_source.every(x => sf_mucthuphi_selected_ids.includes(x.id));
  }, [filtered_raw_data_source, sf_mucthuphi_selected_ids]);

  const isPartialSelected = useMemo(() => {
    return filtered_raw_data_source.some(x => sf_mucthuphi_selected_ids.includes(x.id));
  }, [filtered_raw_data_source, sf_mucthuphi_selected_ids]);

  const handleSelectAll = useCallback((checked: boolean) => {
    if (checked) {
      set_sf_mucthuphi_selected_ids(filtered_raw_data_source.map(x => x.id));
    } else {
      set_sf_mucthuphi_selected_ids([]);
    }
  }, [filtered_raw_data_source]);

  const columns = useMemo(() => {
    const result: IDataGridColumn[] = [
      {
        caption: "Tên khoản nộp",
        id: "ten_khoan_nop",
        dataField: "ten_khoan_nop",
        width: 320,
        align: "left",
        headerRender: () => (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Checkbox
              checked={isAllSelected}
              indeterminate={isPartialSelected && !isAllSelected}
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
            <Box sx={{ marginLeft: "8px" }}>Tên khoản nộp</Box>
          </Box>
        ),
        cellRender: (data: any) => {
          const isExpanded = expandedGroups.has(data.nhom_khoan_nop || "Khác");
          const level = data.isGroupHeader ? 0 : 1;
          const isGroup = data.isGroupHeader;

          if (isGroup) {
            const groupKey = data.nhom_khoan_nop || "Khác";
            const groupItems = raw_data_source.filter(
              (item) => (item.nhom_khoan_nop || "Khác") === groupKey
            );
            const groupItemIds = groupItems.map((item) => item.id);
            const isAllGroupSelected =
              groupItemIds.length > 0 &&
              groupItemIds.every((id) =>
                sf_mucthuphi_selected_ids.includes(id)
              );
            const isPartialGroupSelected = groupItemIds.some((id) =>
              sf_mucthuphi_selected_ids.includes(id)
            );

            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                <IconButton
                  icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                  aria-label=""
                  variant="invisible"
                  size="small"
                  onClick={() => toggleGroup(groupKey)}
                />
                <Checkbox
                  checked={isAllGroupSelected}
                  indeterminate={isPartialGroupSelected && !isAllGroupSelected}
                  onChange={(e) =>
                    handleGroupSelection(groupKey, e.target.checked)
                  }
                />
                <Box
                  sx={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    marginLeft: "8px",
                    color: "#0969da",
                  }}
                >
                  Nhóm: {groupKey}
                </Box>
              </Box>
            );
          } else {
            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ width: `${level * 30}px` }}>&nbsp;</Box>
                <Checkbox
                  checked={sf_mucthuphi_selected_ids.includes(data.id)}
                  onChange={(e) =>
                    handleItemSelection(data.id, e.target.checked)
                  }
                />
                <Box sx={{ marginLeft: "8px", flex: 1 }}>
                  <TextWithEllipse
                    text={data.ten_khoan_nop || ""}
                    lineNumber={2}
                  />
                </Box>
              </Box>
            );
          }
        },
      },
      {
        caption: "Mã khoản nộp",
        id: "ma_khoan_nop",
        dataField: "ma_khoan_nop",
        width: 150,
        align: "left",
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          return (
            <TextWithEllipse text={data.ma_khoan_nop || ""} lineNumber={1} />
          );
        },
      },
      // {
      //   caption: "Số tiền định mức",
      //   id: "so_tien",
      //   dataField: "so_tien",
      //   width: 150,
      //   align: "right",
      //   isAllowFocus: false,
      //   cellRender: (data: any) => {
      //     if (data.isGroupHeader) {
      //       return <span></span>;
      //     }
      //     return (
      //       <div style={{ textAlign: "right" }}>
      //         {formatVND(data.so_tien || 0)}
      //       </div>
      //     );
      //   },
      // },
      {
        caption: "Số tiền định mức",
        id: "so_tien_phai_nop",
        dataField: "so_tien_phai_nop",
        width: 150,
        align: "right",
        isAllowFocus: true,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const value = data.so_tien_phai_nop || 0;
          const rowId = data.id;
          return (
            <Box
              sx={{
                width: "100%",
                textAlign: "right",
                "& .dx-texteditor-input": {
                  textAlign: "right",
                },
              }}
            >
              <NumberBox
                value={value}
                format="#,##0"
                width="100%"
                stylingMode="outlined"
                onValueChanged={(e) => {
                  if (
                    e.value !== null &&
                    e.value !== undefined &&
                    e.value !== value
                  ) {
                    handleSoTienChange(rowId, e.value);
                  }
                }}
              />
            </Box>
          );
        },
      },
      {
        caption: "Ghi chú",
        id: "ghi_chu",
        dataField: "ghi_chu",
        width: 250,
        align: "left",
        isAllowFocus: true,
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const value = data.ghi_chu || "";
          const rowId = data.id;
          return (
            <Box sx={{ width: "100%" }}>
              <TextInput
                value={value}
                onChange={(e) => {
                  if (e.target.value !== value) {
                    handleGhiChuChange(rowId, e.target.value);
                  }
                }}
                sx={{ width: "100%" }}
              />
            </Box>
          );
        },
      },
      {
        caption: "#",
        id: "actions",
        dataField: "actions",
        width: 80,
        align: "center",
        isAllowFocus: false,
        cellRender: (data: any) => {
          // console.log('data', data);
          if (data.isGroupHeader) {
            return <span></span>;
          }
          const canHide = (data.is_dichvu || data.is_dichvu_fixed) && !data.is_khoannop_undefined;
          if (canHide) {
            return <span></span>;
          }
          return (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <IconButton
                icon={TrashIcon}
                aria-label="Ẩn khoản nộp"
                variant="danger"
                size="small"
                disabled={hidingId === data.sf_khoannop_id}
                onClick={(e) => {
                  e.stopPropagation();
                  handleHideItem(data.sf_khoannop_id);
                }}
              />
            </Box>
          );
        },
      },
    ];

    return result;
  }, [
    expandedGroups,
    sf_mucthuphi_selected_ids,
    raw_data_source,
    toggleGroup,
    handleGroupSelection,
    handleItemSelection,
    handleSoTienChange,
    handleGhiChuChange,
    handleHideItem,
    hidingId,
    isAllSelected,
    isPartialSelected,
    handleSelectAll,
  ]);

  return (
    <DefaultPopup width="80%" title={"Thêm chứng từ"} onClose={props.onCancel}>
      <div>

        {isShowHinhThucModal && (
          <SalesetKhoanNopGroupTypeModal
            ts_hocsinh_id={props.ts_hocsinh_id}
            onCancel={() => setIsShowHinhThucModal(false)}
            onSuccess={() => setIsShowHinhThucModal(false)}
          />
        )}

        {isShowThemKhoanNopModal && (
          <ThemKhoanNopModal
            nam_hoc={props.nam_hoc}
            ts_hocsinh_id={props.ts_hocsinh_id}
            existingKhoanNopIds={raw_data_source.filter(x => (x.so_tien_hoan_phi || 0) <= 0).map((x) => x.sf_khoannop_id).filter(Boolean)}
            onAdd={(newItems) => {
              set_sf_mucthuphi_datasource((prev) => {
                const existingIds = new Set(prev.map((x) => x.id));
                const toAdd = newItems
                  .filter((x) => !existingIds.has(x.id))
                  .map((x) => ({
                    id: x.id,
                    sf_khoannop_id: x.sf_khoannop_id ?? x.id,
                    sf_mucthuphi_id: x.sf_khoannop_id ?? x.id,
                    sf_khoannop_group_id: x.sf_khoannop_group_id ?? 0,
                    ma_khoan_nop: x.ma_khoan_nop || x.ma_khoannop || "",
                    ten_khoan_nop: x.ten_khoan_nop || x.ten_khoannop || "",
                    nhom_khoan_nop: x.nhom_khoan_nop || x.nhom_khoannop || "Khác",
                    thutu_sapxep_nhomkhoannop: x.thutu_sapxep_nhomkhoannop ?? 0,
                    thutu_sapxep: x.thutu_sapxep ?? 0,
                    so_tien: x.so_tien || 0,
                    so_tien_phai_nop: x.so_tien_phai_nop || x.so_tien || 0,
                    so_tien_mien_giam: x.so_tien_mien_giam || 0,
                    so_tien_da_nop: x.so_tien_da_nop || 0,
                    ghi_chu: x.ghi_chu || "",
                    sf_hinhthucnopbom_ids: x.sf_hinhthucnopbom_ids || "",
                    thang: x.thang ?? 0,
                    is_dichvu: x.is_dichvu ?? false,
                    is_dichvu_fixed: x.is_dichvu_fixed ?? false,
                    is_khoannop_undefined: x.is_khoannop_undefined ?? false,
                    isShowPayment: x.isShowPayment ?? false,
                    sf_hachtoan_congno_id: 0,
                  }));
                return [...prev, ...toAdd];
              });
            }}
            onAddAndSubmit={(newItems) => {
              set_sf_mucthuphi_datasource((prev) => {
                const existingIds = new Set(prev.map((x) => x.id));
                const toAdd = newItems
                  .filter((x) => !existingIds.has(x.id))
                  .map((x) => ({
                    id: x.id,
                    sf_khoannop_id: x.sf_khoannop_id ?? x.id,
                    sf_mucthuphi_id: x.sf_khoannop_id ?? x.id,
                    sf_khoannop_group_id: x.sf_khoannop_group_id ?? 0,
                    ma_khoan_nop: x.ma_khoan_nop || x.ma_khoannop || "",
                    ten_khoan_nop: x.ten_khoan_nop || x.ten_khoannop || "",
                    nhom_khoan_nop: x.nhom_khoan_nop || x.nhom_khoannop || "Khác",
                    thutu_sapxep_nhomkhoannop: x.thutu_sapxep_nhomkhoannop ?? 0,
                    thutu_sapxep: x.thutu_sapxep ?? 0,
                    so_tien: x.so_tien || 0,
                    so_tien_phai_nop: x.so_tien_phai_nop || x.so_tien || 0,
                    so_tien_mien_giam: x.so_tien_mien_giam || 0,
                    so_tien_da_nop: x.so_tien_da_nop || 0,
                    ghi_chu: x.ghi_chu || "",
                    sf_hinhthucnopbom_ids: x.sf_hinhthucnopbom_ids || "",
                    thang: x.thang ?? 0,
                    is_dichvu: x.is_dichvu ?? false,
                    is_dichvu_fixed: x.is_dichvu_fixed ?? false,
                    is_khoannop_undefined: x.is_khoannop_undefined ?? false,
                    isShowPayment: x.isShowPayment ?? false,
                    sf_hachtoan_congno_id: 0,
                  }));
                const updatedDatasource = [...prev, ...toAdd];

                // Tự động chọn các items vừa thêm và submit
                const newIds = toAdd.map((x) => x.id);
                set_sf_mucthuphi_selected_ids((prevSelected) => [...prevSelected, ...newIds]);

                // Gọi submit sau khi update xong
                setTimeout(() => {
                  const data = {
                    sf_bom_id: 0,
                    is_calculate_miengiam: is_tinh_mien_giam,
                    sf_bom_chitiets: updatedDatasource.filter((x) =>
                      [...sf_mucthuphi_selected_ids, ...newIds].includes(x.id)
                    ),
                    sf_mucthuphis: updatedDatasource.filter((x) =>
                      [...sf_mucthuphi_selected_ids, ...newIds].includes(x.id)
                    ),
                    sf_hinhthucnopbom_id: 0,
                  };
                  props.onSelected(data);
                }, 100);

                return updatedDatasource;
              });
            }}
            onClose={() => setIsShowThemKhoanNopModal(false)}
          />
        )}

        {isShowThemHeClbKhacModal && (
          <ThemHeClbKhacModal
            nam_hoc={props.nam_hoc}
            ts_hocsinh_id={props.ts_hocsinh_id}
            onAdd={(newItems) => {
              set_sf_mucthuphi_datasource((prev) => {
                const existingIds = new Set(prev.map((x) => x.id));
                const toAdd = newItems
                  .filter((x) => !existingIds.has(x.id))
                  .map((x) => ({
                    id: x.id,
                    sf_khoannop_id: x.sf_khoannop_id ?? x.id,
                    sf_mucthuphi_id: x.sf_khoannop_id ?? x.id,
                    sf_khoannop_group_id: x.sf_khoannop_group_id ?? 0,
                    ma_khoan_nop: x.ma_khoan_nop || x.ma_khoannop || "",
                    ten_khoan_nop: x.ten_khoan_nop || x.ten_khoannop || "",
                    nhom_khoan_nop: x.nhom_khoan_nop || x.nhom_khoannop || "Khác",
                    thutu_sapxep_nhomkhoannop: x.thutu_sapxep_nhomkhoannop ?? 0,
                    thutu_sapxep: x.thutu_sapxep ?? 0,
                    so_tien: x.so_tien || 0,
                    so_tien_phai_nop: x.so_tien_phai_nop || x.so_tien || 0,
                    so_tien_mien_giam: x.so_tien_mien_giam || 0,
                    so_tien_da_nop: x.so_tien_da_nop || 0,
                    ghi_chu: x.ghi_chu || "",
                    sf_hinhthucnopbom_ids: x.sf_hinhthucnopbom_ids || "",
                    thang: x.thang ?? 0,
                    is_dichvu: x.is_dichvu ?? false,
                    is_dichvu_fixed: x.is_dichvu_fixed ?? false,
                    is_khoannop_undefined: x.is_khoannop_undefined ?? false,
                    isShowPayment: x.isShowPayment ?? false,
                    sf_hachtoan_congno_id: 0,
                  }));
                return [...prev, ...toAdd];
              });
            }}
            onAddAndSubmit={(newItems) => {
              set_sf_mucthuphi_datasource((prev) => {
                const existingIds = new Set(prev.map((x) => x.id));
                const toAdd = newItems
                  .filter((x) => !existingIds.has(x.id))
                  .map((x) => ({
                    id: x.id,
                    sf_khoannop_id: x.sf_khoannop_id ?? x.id,
                    sf_mucthuphi_id: x.sf_khoannop_id ?? x.id,
                    sf_khoannop_group_id: x.sf_khoannop_group_id ?? 0,
                    ma_khoan_nop: x.ma_khoan_nop || x.ma_khoannop || "",
                    ten_khoan_nop: x.ten_khoan_nop || x.ten_khoannop || "",
                    nhom_khoan_nop: x.nhom_khoan_nop || x.nhom_khoannop || "Khác",
                    thutu_sapxep_nhomkhoannop: x.thutu_sapxep_nhomkhoannop ?? 0,
                    thutu_sapxep: x.thutu_sapxep ?? 0,
                    so_tien: x.so_tien || 0,
                    so_tien_phai_nop: x.so_tien_phai_nop || x.so_tien || 0,
                    so_tien_mien_giam: x.so_tien_mien_giam || 0,
                    so_tien_da_nop: x.so_tien_da_nop || 0,
                    ghi_chu: x.ghi_chu || "",
                    sf_hinhthucnopbom_ids: x.sf_hinhthucnopbom_ids || "",
                    thang: x.thang ?? 0,
                    is_dichvu: x.is_dichvu ?? false,
                    is_dichvu_fixed: x.is_dichvu_fixed ?? false,
                    is_khoannop_undefined: x.is_khoannop_undefined ?? false,
                    isShowPayment: x.isShowPayment ?? false,
                    sf_hachtoan_congno_id: 0,
                  }));
                const updatedDatasource = [...prev, ...toAdd];

                // Tự động chọn các items vừa thêm và submit
                const newIds = toAdd.map((x) => x.id);
                set_sf_mucthuphi_selected_ids((prevSelected) => [...prevSelected, ...newIds]);

                // Gọi submit sau khi update xong
                setTimeout(() => {
                  const data = {
                    sf_bom_id: 0,
                    is_calculate_miengiam: is_tinh_mien_giam,
                    sf_bom_chitiets: updatedDatasource.filter((x) =>
                      [...sf_mucthuphi_selected_ids, ...newIds].includes(x.id)
                    ),
                    sf_mucthuphis: updatedDatasource.filter((x) =>
                      [...sf_mucthuphi_selected_ids, ...newIds].includes(x.id)
                    ),
                    sf_hinhthucnopbom_id: 0,
                  };
                  props.onSelected(data);
                }, 100);

                return updatedDatasource;
              });
            }}
            onClose={() => setIsShowThemHeClbKhacModal(false)}
          />
        )}

        {isShowLocModal && (
          <LocHinhThucNopModal
            rawDataSource={raw_data_source}
            sf_hinhthucnopbom_ids={props.sf_hinhthucnopbom_ids}
            dm_coso_id={dm_coso_id}
            ts_hocsinh_id={props.ts_hocsinh_id}
            nam_hoc={props.nam_hoc}
            initialSelection={groupHtnbFilter}
            onApply={(selection) => setGroupHtnbFilter(selection)}
            onClose={() => setIsShowLocModal(false)}
          />
        )}

        <DataGrid
          title={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <label className="form-label">
                Tổng tiền phải nộp:{" "}
                <span style={{ color: "red", fontWeight: 600 }}>
                  {summary?.toLocaleString()}
                </span>{" "}
                VNĐ
              </label>
            </Box>
          }
          actionComponent={<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button
              variant="default"
              size="small"
              leadingVisual={PlusIcon}
              onClick={() => setIsShowThemKhoanNopModal(true)}
            >
              Thêm khoản nộp
            </Button>
            <Button
              variant="default"
              size="small"
              leadingVisual={PlusIcon}
              onClick={() => setIsShowThemHeClbKhacModal(true)}
            >
              Thêm Hè & CLB
            </Button>
            <Button
              variant="default"
              size="small"
              leadingVisual={FilterIcon}
              onClick={() => setIsShowLocModal(true)}
            >
              Lọc dữ liệu {groupHtnbFilter.size > 0 ? `(${groupHtnbFilter.size})` : ""}
            </Button>
            {groupHtnbFilter.size > 0 && (
              <Button
                variant="danger"
                size="small"
                leadingVisual={XCircleFillIcon}
                onClick={() => setGroupHtnbFilter(new Map())}
              >
                Xóa lọc
              </Button>
            )}
          </Box>}
          dataSource={data_source}
          columns={columns as any}
          height={window.innerHeight - 300}
          isLoading={isLoading}
          paging={{ enable: false }}
          filterRow={{ enable: true }}
        />
      </div>
      <ModalActions>
        <Button
          variant="default"
          leadingVisual={XIcon}
          text="Đóng"
          onClick={() => {
            props.onCancel();
          }}
        />
        <Button
          variant="primary"
          leadingVisual={CheckIcon}
          text="Nộp phí"
          isLoading={props.isSaving}
          disabled={sf_mucthuphi_selected_ids.length === 0}
          onClick={handelSubmit}
        />
      </ModalActions>
    </DefaultPopup>
  );
};

